import React, { FC } from "react";
import { YhFormItemsBox } from "@/components/YhFormBox";
import { IYhFormItemsBox, FormItemTypeEnum } from "@/components/YhFormBox/Types";
import { RouterParamType } from "@/model/navModel";
import { DictCodeEnmu } from "@/types/AppDictEnums";
import { useDictModel } from "@/views/base/dict/dictModel";
import { useShipmentDetailModel } from "../shipmentDetailModel";

export const TransportFormBox: FC<RouterParamType> = ({ id, mode }) => {
    const { getSelectedDictOne } = useDictModel(() => []);
    const {
        editFormVal
    } = useShipmentDetailModel();
    const transportFormItem: IYhFormItemsBox = {
        title: "运输信息",
        style: { padding: "10px 0 0 0", marginBottom: "10px", width: "100%" },
        contentClass: "pr-2",
        items: [
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "贸易条款",
                fieldName: "clause",
                options: getSelectedDictOne(DictCodeEnmu.TRADE_CLAUSE),
                disable: true
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "运输方式",
                fieldName: "transportMode",
                options: getSelectedDictOne(DictCodeEnmu.TRANSPORT_MODE),
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "目的地",
                fieldName: "destination",
                disable: true
            }, {
                type: FormItemTypeEnum.Checkbox,
                fieldLabel: "分批",
                fieldName: "batches",
                span: 3,
                labelCol: { span: 8, offset: 8 },
                disable: true
            }, {
                type: FormItemTypeEnum.Checkbox,
                fieldLabel: "装船",
                fieldName: "transship",
                span: 3,
                disable: true
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "装货港",
                fieldName: "shipment",
                options: getSelectedDictOne(DictCodeEnmu.LOAD_PORT),
                disable: true
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "卸货港",
                fieldName: "discharge",
                options: getSelectedDictOne(DictCodeEnmu.DISCHARTGE_PORT),
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "货代公司",
                fieldName: "agentCompany",
                disable:editFormVal.status == 'shipment.bl'
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "唛头",
                fieldName: "shippingMark",
                disable: true
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "运送方式",
                fieldName: "transportCode",
                options: getSelectedDictOne(DictCodeEnmu.DELIVERY_METHOD),
                disable:editFormVal.status == 'shipment.bl'
            }
        ]
    };

    return (
        <YhFormItemsBox {...transportFormItem} />
    )
}